import $ from 'jquery'
import { gsap } from "gsap";
import { ScrollToPlugin } from 'gsap/all';
import { showScrollPrompt, showScrollPromptAfterDelay } from './_scrollPrompt';
gsap.registerPlugin(ScrollToPlugin)

let slideTracker = []
let currentSlide = 0
let autoPlayTimer

$('#play-nav .prev').on('click', function(e){

    pauseAutoPlay()
    stopProgress()

    // kill the current animation
    if(scrollTl)scrollTl.kill()

    // find where you are, then animate
    setCurrentSlide()

    scrollToPosition(slideTracker[currentSlide - 1].offset)
})

$('#play-nav .next').on('click', function(e){
    pauseAutoPlay()
    stopProgress()

    // kill the current animation
    if(scrollTl)scrollTl.kill()

    // find where you are, then animate
    setCurrentSlide()

    scrollToPosition(slideTracker[currentSlide + 1].offset)
})

$('#play-nav .play').on('click', function(e){

    $('#play-nav .active').removeClass('active')
    $('#play-nav .autoplay-on').addClass('active')

    autoPlay = true
    runAutoPlay()
})

$('#play-nav .pause').on('click', function(e){
    pauseAutoPlay()
    stopProgress()
    
    // give it a second to wait for any residual auto play scroll
    setTimeout(function(){
        showScrollPromptAfterDelay(7500)
    }, 2500)
})

export const pauseAutoPlay = () => {
    $('#play-nav .active').removeClass('active')
    $('#play-nav .autoplay-off').addClass('active')

    autoPlay = false
}

let autoPlay = true
function runAutoPlay() {
    clearTimeout(autoPlayTimer)
    if(!autoPlay) return
    setCurrentSlide()
    if(currentSlide+1 != slideTracker.length) {

        // scroll, then call the auto play
        scrollToPosition(slideTracker[currentSlide + 1].offset)

    } else {
        autoPlay = false
    }
}

export let scrollTl 
export function scrollToPosition(off) {
    let timerAmount = window.autoplayTransitionLong
    let d = 1.8
    if(currentSlide == 0) d = 5
    if(currentSlide == 0 && autoPlay) d = 7

    scrollTl = gsap.timeline()
    scrollTl.to(window, {
        scrollTo: off,
        duration: d,
        ease: "power1.inOut",
        onComplete: function(){
            setCurrentSlide()
            enableDisableButtons()

            if(autoPlay) {
                if(slideTracker[currentSlide].isTitle) timerAmount = window.autoplayTransitionShort
                if(currentSlide == 1) timerAmount = 0
            
                handleProgress(timerAmount)
                autoPlayTimer = setTimeout(runAutoPlay, timerAmount)
            }
        }
    })
}

function setSlideTrackerOffsets() {
    slideTracker = []
    $('.sp-slide').each(function(){
        if($(this).attr('id') == 'sp-section-10-slide-1') return

        let off = $(this).first().offset().top
        let wh = $(window).height()

        let item

        // expand your thinking space
        if($(this).attr('id') == 'sp-section-2-slide-1') {
            slideTracker.push({
                offset: off - (wh * 0.2),
                isTitle: true
            })

        } else if($(this).attr('id') == 'sp-section-4-slide-2') {
            slideTracker.push({
                offset: off + (wh * 0.5),
                isTitle: false
            })

        // balancing 
        } else if($(this).attr('id') == 'sp-section-4-slide-4') {
            slideTracker.push({
                offset: off,
                isTitle: false
            })
            slideTracker.push({
                offset: off + wh * 0.9,
                isTitle: false
            })
        
        // multi title
        } else if($(this).attr('id') == 'sp-section-5-slide-2') {
            slideTracker.push({
                offset: off - (wh * 0.35),
                isTitle: false
            })
            slideTracker.push({
                offset: off + (wh * 0.35) + 120,
                isTitle: false
            })
            slideTracker.push({
                offset: off + wh * 1.6 + 240,
                isTitle: false
            })

        } else if($(this).attr('id') == 'sp-section-6-slide-2') {
            slideTracker.push({
                offset: off,
                isTitle: false
            })
            slideTracker.push({
                offset: off + wh * 0.4,
                isTitle: false
            })

        } else if($(this).attr('id') == 'sp-section-9-slide-1') {
            slideTracker.push({
                offset: off - wh * 0.4,
                isTitle: true
            })
            slideTracker.push({
                offset: off,
                isTitle: false
            })
        
        } else if($(this).attr('id') == 'sp-section-10-slide-1') {
            slideTracker.push({
                offset: off - wh * 0.4,
                isTitle: true
            })
            slideTracker.push({
                offset: off + wh * 0.4,
                isTitle: false
            })
            slideTracker.push({
                offset: off + wh * 1.7,
                isTitle: false
            })
            slideTracker.push({
                offset: off + wh * 4.0,
                isTitle: false
            })

        } else {
            slideTracker.push({
                offset: off,
                isTitle: $(this).hasClass('sp-slide-1') ? true : false
            })
        }
    })
    setCurrentSlide()
}

function setCurrentSlide() {
    let currentOff = $('html,body').scrollTop()
    for (let i = 0; i < slideTracker.length; i++) {
        // set the current slide to the first slide bigger or equal to current offset
        if (slideTracker[i].offset >= currentOff) {
            currentSlide = i
            break;
        }

        // if the offset is greater than last slide's offset, make the last slide current slide
        if(i == slideTracker.length - 1) {
            if(currentOff > slideTracker[i].offset) {
                currentSlide = i
            }
        }
    }
}

function enableDisableButtons() {
    let currentOff = $('html,body').scrollTop()

    if(currentOff == 0) {
        $('#play-nav .prev').addClass('disabled')
    } else {
        $('#play-nav .prev').removeClass('disabled')
    }

    if(slideTracker[slideTracker.length - 1] && slideTracker[slideTracker.length - 1].offset && (currentOff >= slideTracker[slideTracker.length - 1].offset)) {
        $('#play-nav .next').addClass('disabled')
        $('#play-nav .play').addClass('disabled')
        pauseAutoPlay()
    } else {
        $('#play-nav .next').removeClass('disabled')
        $('#play-nav .play').removeClass('disabled')
    }
}

function handleProgress(timerAmount) {
    // let currentOff = $('html,body').scrollTop() + .01
    // let percentage = Math.floor(currentOff / $('body').height() * 100) 
    if(autoPlay) {
        gsap.set($('#progress'), {
            opacity: 1,
            width: '0%',
        })
       gsap.to($('#progress'), {
            width: '100%',
            duration: (timerAmount / 1000),
            onComplete: function(){
                gsap.to($('#progress'), {
                    opacity: 0,
                    duration: .3
                })
            },
        })
    }
}

function stopProgress() {
    gsap.to($('#progress'), {
        opacity: 0,
        duration: 0.3
    })
}

if($('body').hasClass('page-template-page-sp-php')) {
    $(window).on('load', function(){
        if($('body').hasClass('page-template-page-sp-php')) {
            setSlideTrackerOffsets()
            enableDisableButtons()
        }
    })

    // window resize, only fire at end of resize action
    let rtime;
    let timeout = false;
    let delta = 200;
    $(window).on('resize', function(){
        rtime = new Date();
        if (timeout === false) {
            timeout = true;
            setTimeout(handleResize, delta);
        }
    })
    function handleResize() {
        if (new Date() - rtime < delta) {
            setTimeout(handleResize, delta);
        } else {
            timeout = false;
            setSlideTrackerOffsets()
            enableDisableButtons()
        }
    }



    // window scroll
    let rtime2;
    let timeout2 = false;
    let delta2 = 160;
    $(window).on('scroll', function(){
        rtime2 = new Date();
        if (timeout2 === false) {
            timeout2 = true;
            setTimeout(handleScroll, delta2);
        }
    })
    function handleScroll() {
        if (new Date() - rtime2 < delta2) {
            setTimeout(handleScroll, delta2);
        } else {
            timeout2 = false;
            enableDisableButtons()
        }   
    }

}